import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { WarningIcon } from '@/components/Icons/WarningIcon';

function PaymentError(props) {
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 2.5,
				border: 1,
				borderRadius: 1,
				px: 3,
				py: 2,
				borderColor: 'error.main',
				color: 'error.main'
			}}
		>
			<WarningIcon
				style={{
					width: 20,
					height: 20
				}}
			/>

			<Typography
				variant="body1"
				fontWeight={600}
				color="error.main"
				{...props}
			/>
		</Box>
	);
}

export default PaymentError;
